module.exports = __webpack_public_path__ + "static/media/7cricketlogo.a6c40ea9.png";